import React, {useState} from "react";
import AirflowDagLogs from "../Components/airflow/dagLogs/AirflowDagLogs";
import ProjectionsUpload from "./Components/ProjectionsUpload";
import VersionSelect from "./Components/VersionSelect";
import UploadTemplateHelp from "./Components/UploadTemplateHelp";
import {uploadTemplates} from "./uploadTemplates";
import {CELL_TO_MARKETS_DAG_NAME, cellToMarketsVersionPath} from "./cellToMarkets";

const ProjectionCellToMarkets = () => {
    const [loadingCSV, setLoadingCSV] = useState(false)
    const [version, setVersion] = useState("");
    const [dagLogsRefreshTrigger, setDagLogsRefreshTrigger] = useState(undefined);

    return (
        <>
            {!loadingCSV &&
                <div className={'projection-upload-trigger-dag-page-controls'}>
                        <div className={'projection-upload-select-container'}>
                            <VersionSelect version={version} setVersion={setVersion} restrictToAvailableVersions />
                        </div>
                        <ProjectionsUpload
                            getUploadUrl={() => `${process.env.REACT_APP_EDP_API_BASE_URL}/uploadCellToMarkets`}
                            getUploadAdditionalData={() => ({version: version.trim()})}
                            getDagName={() => CELL_TO_MARKETS_DAG_NAME}
                            getDagRunConf={(file) => ({
                                input_filepath: cellToMarketsVersionPath(version.trim()),
                                input_filename: file.name,
                                version: version.trim(),
                            })}
                            setLoading={setLoadingCSV}
                            setDisabled={!version.trim()}
                            onDagTriggered={() => setDagLogsRefreshTrigger(Date.now())}
                        />
                        <UploadTemplateHelp template={uploadTemplates.cellToMarkets}/>
                </div>
            }
            <div className="sld-dag-airflowlogs-container" data-testid="airflow-logs-container">
                <h5>DAG Run Logs</h5>
                <AirflowDagLogs includeDagName={true}
                                includeVersion={true}
                                setAutoRefresh={true}
                                refreshTrigger={dagLogsRefreshTrigger}
                                processName={CELL_TO_MARKETS_DAG_NAME}/>
            </div>
        </>

    )
}

export default ProjectionCellToMarkets;